import {
  AfterViewInit,
  Component,
  HostBinding,
  Input,
  OnDestroy,
  TemplateRef,
  ViewChild,
} from '@angular/core';

import { MwFormDataService } from '../@services';
import { MwFormBaseSectionComponent } from '../section-base.component';

export const MwFormWidgetSelector = 'mw-form-widget';

@Component({
  selector: MwFormWidgetSelector,
  template: '<ng-template><ng-content></ng-content></ng-template>',
})
export class MwFormWidgetComponent
  implements AfterViewInit, OnDestroy, MwFormBaseSectionComponent
{
  static id = 1;

  @HostBinding(`attr.id`)
  idAttr = `mw-from-widget-${MwFormWidgetComponent.id++}`;

  @HostBinding(`class.bg-white`)
  isCard = true;

  @Input() title: string;
  @Input() icon: string;
  @Input() subTitle: string;
  @Input() defaultSubTitle: string;
  @Input() isOutlineIcon: boolean;
  @Input() subTitleIndicators: string;
  @Input() orderIndex = 9999;

  @ViewChild(TemplateRef) templateRef: TemplateRef<any>;

  readonly isFormTitle = false;
  readonly isNavigationWidget = true;

  constructor(private readonly dataService: MwFormDataService) {}

  ngAfterViewInit(): void {
    this.dataService.addSection(this);
  }

  ngOnDestroy(): void {
    this.dataService.removeSection(this);
  }
}
